import { Text } from 'components/Text'
import { Badge, BlogHeroRoot, Wrapper, PointedLine, SadDog } from './BlogHero.styles'
import Image from 'next/image'

import * as sadDog from '../../../../../../../public/assets/blog/sad-dog.webp'
import * as badgeRightest from '../../../../../../../public/assets/badge-rightest.svg'
import { Stack } from 'components/Stack'

export const BlogHero = () => {
  return (
    <BlogHeroRoot>
      <Wrapper>
        <SadDog>
          <Image src={sadDog} alt="" />
        </SadDog>

        <Badge>
          <Image src={badgeRightest} alt="" />
        </Badge>

        <Stack
          direction="column"
          gap={{ '@initial': '1', '@bp2': '3' }}
          justifyContent="center"
          alignItems="center"
        >
          <div>
            <Text
              as="h1"
              size="h1"
              display="block"
              color="primary-500"
              weight="bold"
              align="center"
            >
              THE RAW REPORT
            </Text>
            <Text
              as="p"
              display="block"
              size="headline"
              color="accent-black"
              weight="bold"
              align="center"
            >
              Tips + Advice for a Healthy Dog Life
            </Text>
          </div>
          <PointedLine />
        </Stack>
      </Wrapper>
    </BlogHeroRoot>
  )
}
